/**
 *****************************************
 *********** Dispatch Types **************
 *****************************************
 */
export const ITEM_TYPE_LOADING = "ITEM_TYPE_LOADING";
export const ITEM_TYPE_FAIL = "ITEM_TYPE_FAIL";
export const ITEM_TYPE_LIST = "ITEM_TYPE_LIST";
export const ITEM_TYPE_PUT = "ITEM_TYPE_PUT";
export const ITEM_TYPE_CREATE = "ITEM_TYPE_CREATE";
export const ITEM_TYPE_UPDATE_PER_LABEL_VALUE = "ITEM_TYPE_UPDATE_PER_LABEL_VALUE";
export const ITEM_TYPE_REFRESH = "ITEM_TYPE_REFRESH";
export const ITEM_TYPE_FILTERS = "ITEM_TYPE_FILTERS";
export const MASS_ITEM_STATUS = "MASS_ITEM_STATUS";
export const MASS_ITEM_LIST = "MASS_ITEM_LIST";
export const RETRY_MASS_ITEM_PROCESS_LOADING = "RETRY_MASS_ITEM_PROCESS_LOADING";
export const RETRY_MASS_ITEM_PROCESS_SUCCESS = "RETRY_MASS_ITEM_PROCESS_SUCCESS";
export const RETRY_MASS_ITEM_PROCESS_FAIL = "RETRY_MASS_ITEM_PROCESS_FAIL";
/**
 *****************************************
 ************* Object Types **************
 *****************************************
 */
export type ItemType = {
  id: number,
  taxPercentage: number,
  name: string,
  image_url: string,
  description: string,
  isDeleted: boolean,
  isPublished: boolean
};

export type ItemTypeList = {
  first: boolean
  last: boolean
  number: number
  size: number
  totalPages: number
  categories: ItemType[]
};



export interface ItemMass {
  creationDate: string;
  id: number;
  labelName: string;
  labelValueName: string;
  itemTypeName: string;
  processName: string;
  runDate: string;
  status: string;
}

export interface Pagination {
  empty: boolean;
  first: boolean;
  last: boolean;
  number: number;
  numberOfElements: number;
  pageable: {
    offset: number;
    pageNumber: number;
    pageSize: number;
    paged: boolean;
    sort: {
      empty: boolean;
      sorted: boolean;
      unsorted: boolean;
    };
    unpaged: boolean;
  };
  size: number;
  sort: {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;
  };
  totalElements: number;
  totalPages: number;
}

export interface MassItemsResponse {
  data: {
    content: ItemMass[];
  } & Pagination;
  message: string;
  status: string;
  status_code: number;
}

interface StatusResponse {
  status_code: number;
  status: string;
  message: string;
  data: string[];
}

/**
 *****************************************
 *********** Interfaces Types ************
 *****************************************
 */
export interface ItemTypeLoading {
  type: typeof ITEM_TYPE_LOADING
  payload: string
};

export interface ItemTypeFail {
  type: typeof ITEM_TYPE_FAIL
  payload: string
};

export interface ItemTypeListC {
  type: typeof ITEM_TYPE_LIST,
  payload: ItemTypeList
};

export interface ItemTypeUpdate {
  type: typeof ITEM_TYPE_PUT,
  payload: string
};

export interface ItemTypeCreate {
  type: typeof ITEM_TYPE_CREATE,
  payload: string
};

export interface ItemTypeUpdatePerLabelValue {
  type: typeof ITEM_TYPE_UPDATE_PER_LABEL_VALUE,
  payload: string
};

export interface ItemTypeRefresh {
  type: typeof ITEM_TYPE_REFRESH,
  payload: boolean
};

export interface ItemTypeFilters {
  type: typeof ITEM_TYPE_FILTERS,
  payload: object
};

export interface MassItemStatus {
  type: typeof MASS_ITEM_STATUS
  payload: StatusResponse; 
}

export interface MassItemList {
  type: typeof MASS_ITEM_LIST
  payload: MassItemsResponse;
}

export interface RetryMassItemProcessLoading {
  type: typeof RETRY_MASS_ITEM_PROCESS_LOADING
  payload: string
}

export interface RetryMassItemProcessSuccess {
  type: typeof RETRY_MASS_ITEM_PROCESS_SUCCESS
  payload: string
}

export interface RetryMassItemProcessFail {
  type: typeof RETRY_MASS_ITEM_PROCESS_FAIL
  payload: string
}

// Export types.
export type ItemTypeDispatchTypes = ItemTypeLoading | ItemTypeFail | ItemTypeListC | ItemTypeUpdate | ItemTypeCreate | ItemTypeUpdatePerLabelValue | 
ItemTypeRefresh | ItemTypeFilters | MassItemStatus | MassItemList | RetryMassItemProcessLoading | RetryMassItemProcessSuccess | RetryMassItemProcessFail;
